// 값을 el.value = x 로 직접 대입하면 MUI TextField 라벨의 shrink 상태가 갱신되지 않아
// 값과 라벨 텍스트가 겹쳐 보인다. 네이티브 setter로 값을 넣은 뒤 input 이벤트를 발생시켜
// React/MUI가 값 변경을 정상적으로 인식하도록 한다.
export function setInputValue(id, value) {
  const el = document.getElementById(id);
  if (!el) return;

  const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
  if (setter) {
    setter.call(el, value);
  } else {
    el.value = value;
  }
  el.dispatchEvent(new Event('input', { bubbles: true }));
}
